'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  color: ', ';\n  position: absolute;\n  font-size: 16px !important;\n  top: 50%;\n  transform: translateY(-50%);\n  pointer-events: none;\n  ', ';\n'], ['\n  color: ', ';\n  position: absolute;\n  font-size: 16px !important;\n  top: 50%;\n  transform: translateY(-50%);\n  pointer-events: none;\n  ', ';\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Icon = require('../../Icon/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _colors = require('../../../libs/colors');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
} // Components
// Styles


var TextIcon = (0, _styledComponents2.default)(_Icon2.default)(_templateObject, _colors.darkGrey, function (_ref) {
  var position = _ref.position;
  return position + ': 10px';
});
TextIcon.propTypes = {
  position: _propTypes2.default.oneOf(['left', 'right'])
};
TextIcon.defaultProps = {
  position: 'left'
};
exports.default = TextIcon;